import Hero from '../components/Hero';
import SocialProof from '../components/SocialProof';
import MiniGenerator from '../components/MiniGenerator';
import Stats from '../components/Stats';
import BeforeAfter from '../components/BeforeAfter';
import HowItWorks from '../components/HowItWorks';
import Features from '../components/Features';
import NicheExamples from '../components/NicheExamples';
import PricingTable from '../components/PricingTable';
import FAQ from '../components/FAQ';
import FinalCTA from '../components/FinalCTA';

export default function LandingPage() {
  return (
    <div className="landing-page-container">
      <Hero />
      <div className="divider"></div>
      <SocialProof />
      <div className="divider"></div>
      <MiniGenerator />
      <div className="divider"></div>
      <Stats />
      <div className="divider"></div>
      <BeforeAfter />
      <div className="divider"></div>
      <HowItWorks />
      <div className="divider"></div>
      <Features />
      <div className="divider"></div>
      <NicheExamples />
      <div className="divider"></div>
      <PricingTable />
      <div className="divider"></div>
      <FAQ />
      <div className="divider"></div>
      <FinalCTA />
    </div>
  );
}